import React from 'react';

// Visible camera-video state for a feed: load failures with Retry (rows are
// withheld meanwhile) and explicit continuation for older videos.
export default function CameraMediaFeedStatus({ feed }) {
  if (!feed) return null;
  return (
    <div className="camera-media-feed-status">
      {feed.checking && !feed.error && <p role="status">Checking videos…</p>}
      {feed.error && <p role="alert">{feed.error} Videos are hidden until they can be checked again. <button type="button" onClick={feed.retry}>Retry videos</button></p>}
      {feed.canLoadMore && <button type="button" className="camera-secondary-btn" onClick={feed.loadMore}>Load more videos</button>}
    </div>
  );
}
